<template>
    <l-layout :layout="['xs12']">
      <l-data-table
      :headers="header"
      :get-data-func="getApplyList"
      v-model="selected"
      ref="teacherList"
      hide-title-search
      :filter-items="filter"
      selectable>
        <template slot="filter:stTime">
          <l-select-date label="轮班开始日期" v-model="filter[0].value"></l-select-date>
        </template>
        <template slot="filter:edTime">
          <l-select-date label="轮班截止日期" v-model="filter[1].value"></l-select-date>
        </template>
        <template slot="title">
          <span class="pl-2 pr-4">轮班教师管理</span>
          <v-btn flat color="primary"  :loading="loading" @click="deleteTeachersConfirm">批量删除</v-btn>
          <l-select-file
            :dialog-props="importFileProps"
            :hint="'仅支持Excel(.xlsx)文件'"
            @cancel="importFileProps.activate = false"
            @submit="readExcel"
            file-type="excel"
            select-type="dialog"
          >
            <v-btn class="mx-0" color="primary" flat
                   slot="activator" :disabled="disabledFlag">批量导入
            </v-btn>
            <template slot="before-drag">
              <v-layout align-center class="mb-3 pl-2" row>
                <span class="body-2">批量导入行人需要上传特定格式的模板</span>
                <v-btn
                  :disabled="disabledFlag"
                  @click="getFileTemplate"
                  color="primary"
                  flat
                  ref="templateBtn"
                  small
                  target="_blank"
                >点此下载
                </v-btn>
              </v-layout>
            </template>
          </l-select-file>
          <v-btn flat color="primary"  :loading="loading" @click="outputExcel_2">数据导出</v-btn>
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-btn icon  @click="deleteTeacherConfirm(item)">
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
          </td>
        </template>
      </l-data-table>
      <v-dialog width="1000" v-model="confirmDialog.activated">
        <v-layout column>
          <v-card>
            <v-card-title>
              <p class="title">批量导入确认</p>
            </v-card-title>
            <v-layout column>
              <l-data-table
                :items="importList"
                :headers="header"
                v-show="importList.length>0"
                hide-title
                hide-title-search></l-data-table>
              <v-layout justify-center>
                <v-btn class="primary" @click="importTeacherSubmit" :loading="loading">确定</v-btn>
                <v-btn class="error" @click="resetImport">取消</v-btn>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
      </v-dialog>
      <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog.activate">
        <v-card>
          <v-card-title style="height: 64px;">
            <span class="title">导入轮班教师发生错误</span>
          </v-card-title>
          <v-card-text style="min-height: 350px; max-height: 500px">
            <div class="mb-4" v-if="importErrorDialog.duplicates.length > 0">
              <div class="subheading py-2">以下人员已在导入列表中</div>
              <!--<v-divider></v-divider>-->
              <l-data-table
                :headers="header"
                :items="importErrorDialog.duplicates"
                auto-actions
                flat
                hide-headers
                hide-title
              ></l-data-table>
            </div>
            <div v-if="importErrorDialog.vehicles.length > 0">
              <div class="py-2">
                <div class="subheading">以下人员信息正确，等待导入</div>
                <div class="py-1" v-if="importErrorDialog.haveDuplicatePlate">
                  <span class="error--text caption">您导入的模板中含有重复的条目，导入时将以重复数据的第一条为准</span>
                </div>
              </div>
              <!--<v-divider></v-divider>-->
              <l-data-table
                :headers="header"
                :items="importErrorDialog.vehicles"
                auto-actions
                flat
                hide-headers
                hide-title
              ></l-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="importTeacher(0)" color="grey" flat large>取消导入</v-btn>
            <v-btn :disabled="importErrorDialog.vehicles.length === 0"
                   @click="importTeacher(importErrorDialog.vehicles)"
                   color="error" flat large>仍然导入
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </l-layout>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable"
    import XLSX from 'xlsx'
    import {time} from "../../../ladmin/utils/time";
    import LSelectDatetime from "../../../ladmin/components/LSelectDatetime/LSelectDatetime";
    import { exportExcel } from 'xlsx-oc'
    import 'js-export-excel'
    import LSelectDate from "../../../ladmin/components/LSelectDate/LSelectDate";
    export default {
        name: "teacherManagement",
      components: {LSelectDate, LSelectDatetime, LDataTable},
      data(){
          return {
            selected:[],
            loading:false,
            disabledFlag:false,
            importList:[],
            importFlag:false,
            confirmDialog: {
              activated:false,
              hint:''
            },
            importFileProps: {
              activate: true,
              autoClose: true,
              title: '批量导入轮班教师',
            },
            importFileRules: [
              v => !(!v || v.length === 0) || '必选',
              v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
            ],
            importErrorDialog: {
              activate: false,
              vehicles: [],
              fails: [],
              duplicates: [],
              haveDuplicatePlate: false,
            },
            header:[
              {text:'教工编号',value:'loginId',sortable:false,align:'left'},
              {text:'教工姓名',value:'name',sortable:false,align:'left'},
              {text:'人员属性',value:'userType',sortable:false,align:'left'},
              {text:'单位名称',value:'orgName',sortable:false,align:'left'},
              {text:'轮班开始日期',value:'stTime',sortable:false,align:'true'},
              {text:'轮班截止日期',value:'edTime',sortable:false,align:'left'},
              {text:'备注',value:'remark',sortable:false,align:'left'},
              {text:'',value:'',sortable:false,align:'left'}
            ],
            filter: [
              {
                prependIcon: '$vuetify.icons.person',
                key: 'stTime',
                value: '',
                label: '用户账号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'edTime',
                value: '',
                label: '用户账号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'loginId',
                value: '',
                label: '教工编号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'name',
                value: '',
                label: '教工姓名',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
            ],
            fileName:"轮班教师管理表.xlsx",
            fileHeader:[
              { k: 'loginId', v: '教工编号' },
              { k: 'name', v: '教工姓名' },
              { k: 'userType', v: '人员属性' },
              { k: 'orgName', v: '单位名称' },
              { k: 'stTime', v: '轮班开始日期' },
              { k: 'edTime', v: '轮班截止日期' },
              { k: 'remark', v: '备注' },
            ],
          }
      },
      methods:{
        dealParams(){
          let stTime = (this.filter[0].value===''||this.filter[0].value===null||this.filter[0].value===undefined)?'2022-12-31':this.filter[0].value.substring(0,10)
          let edTime = (this.filter[1].value===''||this.filter[1].value===null||this.filter[1].value===undefined)?'2019-12-31':this.filter[1].value.substring(0,10)
          let searchParam = {
            'searchParam': {
              'stTime': {
                'operators':[
                  {'keyword': stTime,operator:'LTE'}
                ],
                'order': 'NONE',
                'index':0
              },
              'edTime': {
                'operators':[
                  {'keyword': edTime,operator:'GTE'}
                ],
                'order': 'NONE',
                'index':1
              },
              'auditType': {
                'operators':[
                  {'keyword': '1',operator:'LIKE'}
                ],
                'order': 'NONE',
                'index':2
              },
              'loginId': {
                'operators':[
                  {'keyword': this.filter[2].value,operator:'LIKE'}
                ],
                'order': 'NONE',
                'index':3
              },
              'name': {
                'operators':[
                  {'keyword': this.filter[3].value,operator:'LIKE'}
                ],
                'order': 'NONE',
                'index':4
              },
            },
          }
          console.log(searchParam)
          return searchParam
        },
          async getApplyList({pagination}){
            let params = this.dealParams()
            let {items,amount} = await this.$store.dispatch('school/getTeacherList',{pagination:pagination,params:params})
            return {items:items,amount:amount}
          },
        async importTeacherSubmit(){
          let arr = []
          for(let i=0;i<this.importList.length;i++){
            let t = this.importList[i]
            let obj = {
              "name":t.name,
              "loginId":t.loginId,
              "remark":t.remark,
              "orgId":t.orgId,
              "comment":t.comment,
              "stTime":t.stTime,
              "edTime":t.edTime,
              "userType":t.userType,
              "orgName":t.orgName
            }
            arr.push(obj)
          }
          let params = {
            "tempAuditReq":arr
          }
          try {
            this.loading = true
            let res = await this.$store.dispatch('school/importTeachers',params)
            if(res.data.status === 1){
              this.$L.alert('success',{message:'导入成功'})
              this.confirmDialog.activated = false
              this.$refs.teacherList.refresh()
            }else{
              this.$L.alert('error',{message:"导入失败，原因:"+res.data.msg})
            }
          }catch (e) {

          }finally {
            this.loading = false
          }
        },
        async getFileTemplate () {
          try {
            let url = await this.$store.dispatch('school/getFileTemplate')
            let isSupportDownload = 'download' in document.createElement('a')
            console.log('get url', url, isSupportDownload)
            let el = document.createElement('a')
            el.href = url
            el.target = '_blank'
            el.download = '防疫期间轮班职工名单（××学院）'
            el.style.display = 'none'
            document.body.appendChild(el)
            el.click()
            document.body.removeChild(el)
          }
          catch (e) {
            this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
          }
        },
        resetImport(){
          this.confirmDialog.activated = false
          this.importList = []
        },
        resetImportDialog () {
          this.importErrorDialog = {
            activate: false,
            vehicles: [],
            fails: [],
            duplicates: [],
            haveDuplicatePlate: false,
          }
        },
        importTeacher (teachers) {
          if (teachers) {
            this.importList = []
            console.log(teachers)
            this.importList.push(...teachers)
            this.confirmDialog.activated = true
          }
          this.resetImportDialog()
        },
        checkVehicle (v) {
          return 0
        },
        isEmpty(v){
          return v.loginId===''&&v.name===''&&v.stTime===''&&v.edTime===''&&v.orgName===''&&v.orgId===''
        },
        readExcel (files) {
          let importList = []
          let f = files[0]
          if (!(f instanceof File)) return
          let reader = new FileReader()
          reader.onload = (event) => {
            try {
              let data = event.target.result
              let workbook = XLSX.read(data, {type: 'array'})
              let keys = Object.keys(workbook.Sheets)
              if (Object.keys(workbook.Sheets).length < 1) {
                throw Error('模板格式错误')
              }
              let sheet = workbook.Sheets[keys[0]]
              let ref = sheet['!ref']
              let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
              if (!group) {
                throw Error('模板格式错误')
              }
              let s = Number(group[1])
              let e = Number(group[2])
              console.log(sheet)

              let atters = ['A', 'B', 'C', 'D', 'E', 'F','G','H','I']
              let teachers = []
              let fails = []
              let duplicates = []
              let haveDuplicatePlate = false

              for (let i = s + 1; i <= e; ++i) {
                let loginId = sheet[atters[1] + i] ? sheet[atters[1] + i].w.trim() : ''
                let name = sheet[atters[2] + i] ? sheet[atters[2] + i].w : ''
                let userType = sheet[atters[3] + i] ? sheet[atters[3] + i].w.trim() : ''
                let orgId = sheet[atters[4] + i] ? sheet[atters[4] + i].w.trim() : ''
                let orgName = sheet[atters[5] + i] ? sheet[atters[5] + i].w.trim() : ''
                let stTime = sheet[atters[6] + i] ? sheet[atters[6] + i].w.trim() : ''
                let edTime = sheet[atters[7] + i] ? sheet[atters[7] + i].w.trim() : ''
                let remark = sheet[atters[8] + i] ? sheet[atters[8] + i].w.trim() : ''
                let v = {
                  loginId:loginId,
                  name:name,
                  userType:userType,
                  orgId:orgId,
                  stTime:stTime,
                  edTime:edTime,
                  remark:remark,
                  orgName:orgName
                }
                if(this.isEmpty(v)){
                  continue
                }
                let checkRes = this.checkVehicle(v)
                if (checkRes === 0) {
                  if (this.importList.find(t => (t.loginId === v.loginId&&t.stTime===v.stTime&&t.edTime===v.edTime))) {
                    duplicates.push(v)
                  }
                  else {
                    let tmp = teachers.find(t => (t.loginId === v.loginId&&t.stTime===v.stTime&&t.edTime===v.edTime))
                    if (tmp) {
                      console.log('find duplicate', tmp, v,i)
                      haveDuplicatePlate = true
                    }
                    else {
                      teachers.push(v)
                    }
                  }
                }
              }

              console.log('check import', fails, duplicates, teachers)
              if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
                this.importTeacher(teachers)
              }
              else {
                this.importErrorDialog = {
                  activate: true,
                  vehicles: teachers,
                  fails: fails,
                  duplicates: duplicates,
                  haveDuplicatePlate: haveDuplicatePlate,
                }
              }
            }
            catch (e) {
              console.log(e)
              this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
            }
          }
          reader.readAsArrayBuffer(f)
        },
        async deleteTeacherConfirm (item) {
          let {res, close} = await this.$L.confirm({
            title: '确认删除该轮班教师？',
            text: '教师名称:' + item.name
          })
          if (res) {
            try {
              await this.deleteTeacher(item)
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deleteTeacher (item) {
          let ids = []
          ids.push(item.id)
          let params = {"ids":ids}
          let res = await this.$store.dispatch('school/deleteTeachers', params)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.teacherList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
        async deleteTeachersConfirm(){
          let {res, close} = await this.$L.confirm({
            title: '确认删除选中的教师？',
          })
          if (res) {
            try {
              await this.deleteTeachers()
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deleteTeachers () {
          let ids = []
          for(let i=0;i<this.selected.length;i++){
            let t = this.selected[i]
            ids.push(t.id)
          }
          let params = {"ids":ids}
          let res = await this.$store.dispatch('school/deleteTeachers', params)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.teacherList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
        async outputExcel(){
          let pagination = {
            page:1,
            rowsPerPage: 10000
          }
          let params = this.dealParams(this.filter)
          this.loading = true
          let res = await this.$store.dispatch('school/getTeacherList',{pagination:pagination,params:params})
          let list = []
          let items = res.items
          list = items
          if(list.length === 0){
            this.$L.alert('error',{message:'未查询到数据无法导出'})
          }else{
            exportExcel(this.fileHeader, list, this.fileName)
          }
          this.loading = false
        },
        async outputExcel_2(){
          let pagination = {
            page:1,
            rowsPerPage: 10000
          }
          let params = this.dealParams(this.filter)
          this.loading = true
          let res = await this.$store.dispatch('school/getTeacherList',{pagination:pagination,params:params})
          let list = []
          let items = res.items
        /*  list = items
          if(list.length === 0){
            this.$L.alert('error',{message:'未查询到数据无法导出'})
          }else{
            exportExcel(this.fileHeader, list, this.fileName)
          }*/
          let option={};
          const ExportJsonExcel = require('js-export-excel')
          items.forEach((item)=>{
            let arr = []
            for(let i in this.fileHeader){
              arr.push(item[this.fileHeader[i].k])
            }
            list.push(arr)
          })
          //console.log(list)
          option.fileName = "轮班教师管理表"
          option.datas=[
            {
              sheetData:list,
              sheetName:'sheet',
              sheetHeader:['教工编号','教工姓名','人员属性','单位名称','轮班开始日期','轮班截止日期','备注'],
            },
          ];
          let toExcel = new ExportJsonExcel(option); //new
          toExcel.saveExcel(); //保存
          this.loading = false
        },
      }
    }
</script>

<style scoped>

</style>
